type CacheEntry<T> = {
  timestampMs: number;
  promise: Promise<T>;
};

export class TtlPromiseCache<T> {
  private store = new Map<string, CacheEntry<T>>();
  private ttlMs: number;

  constructor(ttlMs: number) {
    this.ttlMs = ttlMs;
  }

  get(key: string, fetcher: () => Promise<T>, ttlMsOverride?: number): Promise<T> {
    const now = Date.now();
    const ttlMs = ttlMsOverride ?? this.ttlMs;
    const cached = this.store.get(key);

    if (cached && now - cached.timestampMs < ttlMs) {
      return cached.promise;
    }

    const promise = fetcher().catch((err) => {
      this.store.delete(key);
      throw err;
    });

    this.store.set(key, { timestampMs: now, promise });
    return promise;
  }

  getFresh(key: string, fetcher: () => Promise<T>): Promise<T> {
    this.store.delete(key);
    return this.get(key, fetcher, 0);
  }

  delete(key: string): void {
    this.store.delete(key);
  }

  clear(): void {
    this.store.clear();
  }

  setTtlMs(ttlMs: number): void {
    this.ttlMs = ttlMs;
  }
}
